<template>
  <div id="myMap"
       ref="myMap"
       style="width:100%; height: 100%"></div>
</template>
<script>
var geoCoordMap;
var convertData;
let options;
import cityMap from '../echart/chinaCityGeo.json'
// var data = [{ name: "北京市", value: "12" }];
export default {
  props: ['data'],
  name: "MapScatter",
  data () {
    return {
      max: 0,
      min: 0,
      differenceValue: 1,
      chart: {},
      nature: '销售量'
    };
  },
  mounted () {

    this.getValue();
    this.init();
    this.drawChinaMap();
    //设置点击事件

    this.chart.on("click", params => {
      this.$emit("onClick", params);
    });
  },
  watch: {
    data: {
      handler: function () {
        this.getValue();
        this.init();
        this.drawChinaMap();
      },
      deep: true    }
  },
  created () { },

  methods: {
    drawChinaMap () {
      this.chart = this.$echarts.init(
        this.$el,
        "macarons"
      );

      this.chart.setOption(options, true);
    },
    getValue () {

      let data = this.data;
      let nature = this.nature;
      let arr = [];
      if (nature) {
        data.forEach(item => {
          if (item.name !== "无地址") {
            arr.push(item.value[nature] * 1);
          }
        });
      }
      this.max = Math.max.apply(null, arr);
      this.min = Math.min.apply(null, arr);
      this.differenceValue = (this.max - this.min) / 10;
      if (!this.differenceValue) {
        this.differenceValue = 1;
      }
    },
    init () {
      let cityObj = {};

      for (let item in cityMap) {
        for (let key in cityMap[item]) {
          let x = cityMap[item][key].x;
          let y = cityMap[item][key].y;
          (cityObj[key] = []), cityObj[key].push(x, y);
        }
      }
      let that = this;
      // let cityObj = {
      //   甘肃省: [103.73, 36.03],
      //   青海省: [101.74, 36.56],
      //   四川省: [104.06, 30.67],
      //   河北省: [114.48, 38.03],
      //   云南省: [102.73, 25.04],
      //   贵州省: [106.71, 26.57],
      //   湖北省: [114.31, 30.52],
      //   河南省: [113.65, 34.76],
      //   山东省: [117, 36.65],
      //   江苏省: [118.78, 32.04],
      //   安徽省: [117.27, 31.86],
      //   浙江省: [120.19, 30.26],
      //   江西省: [115.89, 28.68],
      //   福建省: [119.3, 26.08],
      //   广东省: [113.23, 23.16],
      //   湖南省: [113, 28.21],
      //   海南省: [110.35, 20.02],
      //   辽宁省: [123.38, 41.8],
      //   吉林省: [125.35, 43.88],
      //   黑龙江省: [126.63, 45.55],
      //   山西省: [112.53, 37.87],
      //   陕西省: [108.95, 34.27],
      //   台湾省: [121.3, 25.03],
      //   // 4直辖市
      //   北京市: [116.46, 39.92],
      //   上海市: [121.48, 31.22],
      //   重庆市: [106.54, 29.59],
      //   天津市: [117.2, 39.13],
      //   // 5自治区
      //   内蒙古自治区: [111.65, 40.82],
      //   广西壮族自治区: [108.33, 22.84],
      //   西藏自治区: [91.11, 29.97],
      //   宁夏回族自治区: [106.27, 38.47],
      //   新疆维吾尔自治区: [87.68, 43.77],
      //   // 2特别行政区
      //   香港特别行政区: [114.17, 22.28],
      //   澳门特别行政区: [113.54, 22.19]
      // };

      let data = this.data;

      geoCoordMap = cityObj;
      convertData = function (data) {
        var res = [];
        for (var i = 0; i < data.length; i++) {
          var geoCoord = geoCoordMap[data[i].name];
          if (geoCoord) {
            res.push({
              name: data[i].name,
              value: geoCoord.concat(data[i].value)
            });
          }
        }

        return res;
      };

      options = {
        backgroundColor: "transparent",
        title: {
          text: "区域销售量",
          // subtext: "data from PM25.in",
          // sublink: "http://www.pm25.in",
          left: "center",
          textStyle: {
            fontSize: 14 * this.$store.state.ratio.hole,
            color: "#fff"
          }
        },
        tooltip: {
          trigger: "item",
          // triggerOn: "click",
          confine: "true",
          formatter: function (params) {
            let values = params.value[2];

            var res =
              '<div id="tool_dialog_id"><span class="tool_dialog_class"  :style="`font-size:${12*$store.state.ratio.hole}px`">' +
              params.name +
              "<br>";
            for (let item in values) {
              if (typeof values[item] !== "string") {
                res += item + ":" + values[item] + "<br>";
              }
            }
            res += "</span></div>";
            return res;
          }
        },
        // legend: {
        //   orient: "vertical",
        //   y: "bottom",
        //   x: "right",
        //   data: ["pm2.5"],
        //   textStyle: {
        //     color: "#fff"
        //   }
        // },
        geo: {
          map: "china",
          label: {
            emphasis: {
              show: false
            },
            normal: {
              show: true,
              textStyle: {
                fontSize: 10 * this.$store.state.ratio.hole,
                color: '#fff'
              }
            },
          },
          roam: true,
          itemStyle: {
            normal: {
              areaColor: "rgba(34, 160, 255, 1)",
              borderColor: "#111",
            },
            emphasis: {
              areaColor: "#105c9d"
            }
          }
        },
        series: [
          {
            name: "scatter",
            type: "scatter",
            coordinateSystem: "geo",
            data: convertData(data),
            encode: {
              value: 2
            },
            symbolSize: function (val) {
              if (that.nature) {
                let value = val[2][that.nature];
                return (value - that.min) / that.differenceValue + 8;
              }

              return 8;
            },
            label: {
              normal: {
                formatter: "{b}",
                position: "right",
                show: false
              },
              emphasis: {
                show: false
              }
            },
            itemStyle: {
              normal: {
                color: "#E7EE36"
              }
            }
          },
          {
            name: "商品流向",
            type: "effectScatter",
            coordinateSystem: "geo",
            data: convertData(data),
            encode: {
              value: 2
            },
            symbolSize: function (val) {

              if (that.nature) {
                let value = val[2][that.nature];
                return (value - that.min) / that.differenceValue + 8;
              }
              return 8;
            },
            showEffectOn: "render",
            rippleEffect: {
              brushType: "stroke"
            },
            hoverAnimation: true,
            label: {
              normal: {
                formatter: "{b}",
                position: "right",
                show: false
              }
            },
            itemStyle: {
              normal: {
                color: "#E7EE36",
                shadowBlur: 10,
                shadowColor: "#333"
              }
            },
            zlevel: 1
          }
        ]
      };
    }
  }
};
</script>
<style scoped>
canvas {
  width: 100%;
}
#myMap {
  background: transparent;
}
</style>
